import React, {useState} from 'react'

import {Button, Divider, Image, Modal} from 'semantic-ui-react'
import styled from 'styled-components'

import {Loader} from "../Loader";
import scb from './assets/scb.svg'
import bbl from './assets/bbl.svg'
import bay from './assets/bay.svg'
import ktb from './assets/ktb.svg'

const FullWidthButton = styled(Button)`
  width: 100%;
  max-width: 750px;
  min-height: 40px;
  max-height: 55px;
  height: 55px;
`

const StyledSpan = styled.span`
    font-size: 1rem;
    margin-left: 10px;
`

export const InternetBankingButton = ({onClick}) => {
    const [loading, setLoading] = useState(false)
    return (
        <Modal trigger={<FullWidthButton color="teal">อินเตอร์เน็ตแบงค์กิ้ง</FullWidthButton>}>
            <Modal.Header>โปรดเลือกธนาคาร</Modal.Header>
            <Modal.Content>
                <Modal.Description>
                    {loading ? <Loader/> : (
                        <div>
                            <div onClick={() => {
                                onClick('scb')
                                setLoading(true)
                            }}>
                                <Image src={scb} size='tiny' style={{background: '#4e2e7f'}} verticalAlign='middle'/>
                                <StyledSpan>ธนาคารไทยพาณิชย์</StyledSpan>
                            </div>
                            <Divider/>
                            <div onClick={() => {
                                onClick('bbl')
                                setLoading(true)
                            }}>
                                <Image src={bbl} size='tiny' style={{background: '#1e4598'}} verticalAlign='middle'/>
                                <StyledSpan>ธนาคารกรุงเทพ</StyledSpan>
                            </div>
                            <Divider/>
                            <div onClick={() => {
                                onClick('bay')
                                setLoading(true)
                            }}>
                                <Image src={bay} size='tiny' style={{background: '#fec43b'}} verticalAlign='middle'/>
                                <StyledSpan>ธนาคารกรุงศรีอยุธยา</StyledSpan>
                            </div>
                            <Divider/>
                            <div onClick={() => {
                                onClick('ktb')
                                setLoading(true)
                            }}>
                                <Image src={ktb} size='tiny' style={{background: '#1ba5e1'}} verticalAlign='middle'/>
                                <StyledSpan>ธนาคารกรุงไทย</StyledSpan>
                            </div>
                            <Divider/>
                        </div>
                    )}
                </Modal.Description>
            </Modal.Content>
        </Modal>
    )
}



// WEBPACK FOOTER //
// /opt/build/repo/src/components/InternetBankingButton/index.js